﻿import $ from 'jquery';
import _ from 'underscore'

export class AddressLoader {
  public static calculateAddressFromZipcode(e: JQueryEventObject): void {
    var $addressLoader = $(e.target).closest('[data-addressloader]');

    var url = $addressLoader.data('calculate-from-zip-url');
    var zipCode = $addressLoader.find('[data-addressloader-zipcode]').val();

    $addressLoader.remote({
      url: url,
      data: {
        zipCode: zipCode,
        callback: "Rustig.AddressLoader.onAddressOptionsCalculatedFromZipcode"
      }
    });
  }

  public static onAddressOptionsCalculatedFromZipcode(data: any): void {
    data.$remoteTarget.find('[data-addressloader-state]').val(data.state).change();
    data.$remoteTarget.find('[data-addressloader-city]').html(data.cityOptions).trigger('dropdown:reload').val(data.city).change();
    data.$remoteTarget.find('[data-addressloader-county]').html(data.countyOptions).trigger('dropdown:reload').val(data.county).change();
  }

  public static wireupDocument: Function = _.once(() => {
    $(document).on('change.rustig.zipcode', '[data-addressloader-zipcode]', AddressLoader.calculateAddressFromZipcode);
  });

}
